const shipmentDetails = {
  'shipmentDetails.shipmentDetails': '发货单详情',
  'shipmentDetails.updateShipmentStatus': '修改发货单状态',
  'shipmentDetails.saveLogistics': '新增物流单',
  'shipmentDetails.updateLogistics': '修改物流单',

  'shipmentDetails.orderId': '订单ID',
  'shipmentDetails.shipmentId': '发货单ID',
  'shipmentDetails.shipmentId.placeholder': '请输入发货单ID',
  'shipmentDetails.shipmentMethod': '发货方式',
  'shipmentDetails.shipmentDate': '发货日期',
  'shipmentDetails.shipmentStatus': '发货状态',
  'shipmentDetails.shipmentStatusName': '发货状态',

  'shipmentDetails.recipientInfo': '收货信息',
  'shipmentDetails.recipientName': '收货人',
  'shipmentDetails.phone': '联系电话',
  'shipmentDetails.postalCode': '邮政编码',
  'shipmentDetails.email': '邮箱',
  'shipmentDetails.address': '收货地址',

  'shipmentDetails.logisticsList': '物流单列表',
  'shipmentDetails.logisticsList.trackingNumber': '物流单号',
  'shipmentDetails.logisticsList.trackingNumber.placeholder': '请输入物流单号',
  'shipmentDetails.logisticsList.shipmentId': '发货单id',
  'shipmentDetails.logisticsList.carrierName': '承运商',
  'shipmentDetails.logisticsList.carrierName.placeholder': '请输入承运商',
  'shipmentDetails.logisticsList.deliveryStatus': '物流状态',
  'shipmentDetails.logisticsList.shipmentDate': '发货日期',
  'shipmentDetails.logisticsList.shipmentDate.placeholder': '请选择发货日期',
  'shipmentDetails.logisticsList.estimatedArrival': '预计到达日期',
  'shipmentDetails.logisticsList.estimatedArrival.placeholder': '请选择预计到达日期',
  'shipmentDetails.logisticsList.actualArrival': '实际到达日期',
  'shipmentDetails.logisticsList.actualArrival.placeholder': '请选择实际到达日期',
  'shipmentDetails.logisticsList.shipper': '发货人',
  'shipmentDetails.logisticsList.shipper.placeholder': '请输入发货人',
  'shipmentDetails.logisticsList.contact': '联系方式',
  'shipmentDetails.logisticsList.contact.placeholder': '请输入联系方式',
  'shipmentDetails.logisticsList.trackingRecords': '轨迹记录',
  'shipmentDetails.logisticsList.update': '修改',

  'shipmentDetails.trackingRecords.trackingTime': '轨迹时间',
  'shipmentDetails.trackingRecords.trackingLocation': '轨迹位置',
  'shipmentDetails.trackingRecords.remark': '备注',
  'shipmentDetails.trackingRecords.attachment': '附件',
  'shipmentDetails.trackingRecords.update': '更新轨迹',
  'shipmentDetails.trackingRecords.location': '位置',
  'shipmentDetails.trackingRecords.location.placeholder': '请输入位置',
  'shipmentDetails.trackingRecords.time': '时间',
  'shipmentDetails.trackingRecords.time.placeholder': '请选择时间',

  'shipmentDetails.productList': '发货商品列表',
};

export default shipmentDetails;
